import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { graphql, gql, compose } from 'react-apollo';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { Tabs, Tab } from 'material-ui/Tabs';

import Loader from '../../UI/Loader';

import styles from './RegListsList.css';

const regListsQuery = gql`
    query RegListQuery($tournamentId: ID!) {
        regLists(tournamentId: $tournamentId) {
            _id
            town {
                _id
            }
            townName
            orgHeadName
            email
            participantDraftsCount
            season
        }
    }
`;

class RegListsList extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            regLists: PropTypes.array,
        }).isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        season: 'fall',
    };

    openRegList = event => {
        this.props.history.push(
            `/tournaments/${this.props.tournament.number}/reglist/${event.currentTarget.dataset.id}`
        );
    };

    stopPropagation = event => event.stopPropagation();

    render() {
        const {
            intl: { formatMessage },
            data: { regLists, loading },
            tournament,
        } = this.props;

        if (loading) {
            return <Loader centerX />;
        }

        if (!regLists || !regLists.length) {
            return (
                <h2>
                    <FormattedMessage id="RegListsList.No reglists" />
                </h2>
            );
        }

        return (
            <Fragment>
                <Tabs
                    value={this.state.season}
                    onChange={season => this.setState({ season })}
                    tabItemContainerStyle={{ background: 'transparent' }}
                >
                    <Tab
                        label={formatMessage({ id: 'OrgHomePage.fall' })}
                        style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                        value="fall"
                    />
                    {Boolean(tournament.t && tournament.v) && (
                        <Tab
                            label={formatMessage({ id: 'OrgHomePage.spring' })}
                            style={{ color: 'rbga(0, 0, 0, 0.87)' }}
                            value="spring"
                        />
                    )}
                </Tabs>
                <Table>
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        enableSelectAll={false}
                        selectable={false}
                    >
                        <TableRow>
                            <TableHeaderColumn>
                                <FormattedMessage id="RegListsList.townName" />
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <FormattedMessage id="RegListsList.email" />
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <FormattedMessage id="RegListsList.orgHeadName" />
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <FormattedMessage id="RegListsList.participantDraftsCount" />
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                <FormattedMessage id="RegListsList.registration" />
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} showRowHover>
                        {regLists.filter(regList => regList.season === this.state.season).map(regList => (
                            <TableRow
                                selectable={false}
                                onClick={this.openRegList}
                                data-id={regList._id}
                                className={styles.row}
                                key={regList._id}
                            >
                                <TableRowColumn>{regList.townName}</TableRowColumn>
                                <TableRowColumn>{regList.email}</TableRowColumn>
                                <TableRowColumn>{regList.orgHeadName}</TableRowColumn>
                                <TableRowColumn>{regList.participantDraftsCount}</TableRowColumn>
                                <TableRowColumn>
                                    {regList.town ? (
                                        <Link
                                            to={`/tournaments/${tournament.number}/towns/${regList.town._id}/${
                                                this.state.season
                                            }`}
                                            onClick={this.stopPropagation}
                                        >
                                            <FormattedMessage id="RegListsList.town" />
                                        </Link>
                                    ) : (
                                        <Link
                                            to={`/tournaments/${tournament.number}/register/${regList._id}`}
                                            onClick={this.stopPropagation}
                                        >
                                            <FormattedMessage id="RegListsList.register" />
                                        </Link>
                                    )}
                                </TableRowColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Fragment>
        );
    }
}

export default compose(
    graphql(regListsQuery, {
        options: ({ tournament }) => ({
            variables: {
                tournamentId: tournament._id,
            },
        }),
    }),
    injectIntl
)(RegListsList);



// WEBPACK FOOTER //
// ./src/Components/RegListsList/RegListsList.js